/**
 * @generated SignedSource<<8119a2ab6b251379545967d26a4c553f>>
 * @relayHash 019931ecb4d62478ada7dcb38c369407
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c1006bb595d5871def9b45953f93abb35e05f3b2f761dfc9ca352ec5a7d5225c

import type { ConcreteRequest } from 'relay-runtime';
export type WorkspacePermissionsProviderQuery$variables = {
  dontRequirePrincipalsInSite?: ReadonlyArray<boolean | null> | null;
  permissionIds?: ReadonlyArray<string | null> | null;
  principalIds?: ReadonlyArray<string | null> | null;
  resourceIds?: ReadonlyArray<string | null> | null;
  skip: boolean;
};
export type WorkspacePermissionsProviderQuery$data = {
  readonly bulkPermitted?: ReadonlyArray<{
    readonly permissionId: string | null;
    readonly permitted: boolean | null;
  } | null> | null;
};
export type WorkspacePermissionsProviderQuery = {
  response: WorkspacePermissionsProviderQuery$data;
  variables: WorkspacePermissionsProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dontRequirePrincipalsInSite"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissionIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "principalIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v5 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "dontRequirePrincipalsInSite",
            "variableName": "dontRequirePrincipalsInSite"
          },
          {
            "kind": "Variable",
            "name": "permissionIds",
            "variableName": "permissionIds"
          },
          {
            "kind": "Variable",
            "name": "principalIds",
            "variableName": "principalIds"
          },
          {
            "kind": "Variable",
            "name": "resourceIds",
            "variableName": "resourceIds"
          }
        ],
        "concreteType": "BulkPermittedResponse",
        "kind": "LinkedField",
        "name": "bulkPermitted",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionId"
          },
          {
            "kind": "ScalarField",
            "name": "permitted"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WorkspacePermissionsProviderQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspacePermissionsProviderQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "c1006bb595d5871def9b45953f93abb35e05f3b2f761dfc9ca352ec5a7d5225c",
    "metadata": {},
    "name": "WorkspacePermissionsProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8e0438daab88aeec8fade1b553ab0b21";

export default node;
